import * as Dialog from "@radix-ui/react-dialog";
import { Heading, TablePagination, TableSearch } from "components/elements";
import { XMarkIcon } from "components/icons/outline";
import { useDiscussions } from "hooks/useDiscussions";
import { useThrottled } from "hooks/useThrottled";
import { ReactNode, useState } from "react";
import * as React from "react";
import { DiscussionsListTable } from "screens/discussions/DiscussionsListTable";
import { ClientDocument } from "@compass/shared/types";

export const DiscussionsModal = ({
    button,
    document,
    isOpen,
    setIsOpen,
}: {
    button?: ReactNode;
    isOpen: boolean;
    document: ClientDocument;
    setIsOpen: (isOpen: boolean) => void;
}) => {
    const [search, setSearch] = useState<string>("");
    const [page, setPage] = useState<number | undefined>(undefined);
    const throttledSearch = useThrottled(setSearch);
    const { data } = useDiscussions({ search, page, documentId: document?.id ?? undefined });

    if (!document) {
        return null;
    }

    return (
        <Dialog.Root
            open={isOpen}
            onOpenChange={(opened) => {
                setIsOpen(opened);
            }}
        >
            <Dialog.Trigger asChild>{button}</Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-slate-900/20" />
                <Dialog.Content className="fixed top-32 left-1/2 w-full max-w-[800px] -translate-x-1/2 rounded bg-white p-4">
                    <div className="flex flex-row">
                        <Dialog.Title asChild>
                            <Heading>
                                Document: {document.name} used in the following discussions
                            </Heading>
                        </Dialog.Title>
                        <Dialog.Close asChild>
                            <button className="ml-auto" aria-label="Close">
                                <XMarkIcon className="h-4 w-4" />
                            </button>
                        </Dialog.Close>
                    </div>
                    <div className="h-4" />

                    <div className="flex flex-wrap gap-4">
                        <div className="flex w-full flex-col gap-4">
                            <div className="flex flex-row justify-end gap-4">
                                {data && <TableSearch value={search} onChange={throttledSearch} />}
                            </div>

                            {data && <DiscussionsListTable discussions={data?.discussions || []} />}
                            {data && (
                                <TablePagination
                                    total={data?.totalFound}
                                    page={page}
                                    onChangePage={(page) => setPage(page)}
                                />
                            )}
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
